import {NgModule} from '@angular/core';
import {TaskGuiService} from './services/task-gui.service';

@NgModule({
  imports: [],
  declarations: [],
  providers: [TaskGuiService],
})
export class TaskSharedModule {}
